import React, { Component, Fragment } from 'react';

import ModalStylesGradient from '../ModalStylesGradient';

class LinearGradientButton extends Component {
  state = {
    isOpen: false,
    palette: this.props.palette,
  };

  handleOpen = () => {
    this.setState({
      isOpen: true,
    });
  };

  handleClose = () => {
    this.setState({
      isOpen: false,
    });
  };

  onPaletteChange = palette => {
    this.setState({ palette });
  };

  handleAccept = () => {
    const { palette } = this.state;
    const { acceptColor } = this.props;

    let gradient = '';
    const length = palette.palette.length - 1;
    palette.palette.map((el, index) => {
      if (length !== index) {
        return (gradient += `${el.color} ${el.pos * 100}%, `);
      } else {
        return (gradient += `${el.color} ${el.pos * 100}%`);
      }
    });
    acceptColor(gradient);
    this.handleClose();
  };

  render() {
    const { styles, palette } = this.props;
    return (
      <Fragment>
        <button onClick={this.handleOpen} />
        <ModalStylesGradient
          palette={palette}
          isOpen={this.state.isOpen}
          handleClose={this.handleClose}
          handleAccept={this.handleAccept}
          onPaletteChange={this.onPaletteChange}
        />
      </Fragment>
    );
  }
}

export default LinearGradientButton;



// WEBPACK FOOTER //
// ./src/components/LinearGradientButton/LinearGradientButton.js